import React from 'react';
import { useTheme, withStyles } from '@material-ui/core';
import { Stack, Box } from '@mui/material';
import { VTypography } from '@venti-components';
import styles from './styles';

const AutocompleteOption = ({ matches, classes, option, onClick }) => {
  const { label, image } = option;
  const [beforeMatch, matchText, afterMatch] = matches;

  const theme = useTheme();

  return (
    <Stack className={classes.optionBox} direction="row" alignItems="center" onClick={onClick}>
      {image && (
        <Box className={classes.imageWrapper}>
          <img src={image} alt={label} className={classes.image} />
        </Box>
      )}
      <VTypography component="span" color={theme.palette.text.primary}>
        {beforeMatch}
        <strong>{matchText}</strong>
        {afterMatch}
      </VTypography>
    </Stack>
  );
};

export default withStyles(styles)(AutocompleteOption);
